<p-table [value]="actividades" dataKey="id" styleClass="p-datatable-sm p-datatable-gridlines" [loading]="isLoading"
  scrollHeight="600px" [tableStyle]="{'min-width': '40rem'}" [scrollable]="true" [rows]="7">
  <ng-template pTemplate="header">
    <tr customHeader [columns]="columns">
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-actividad let-index="rowIndex">
    <tr>
      <td>
        {{ actividad.actividad }}
      </td>
      <td>{{ actividad.usuarioAsignado }}</td>
      <td class="text-center">
        <p-tag [value]="actividad.estadoDescripcion"
          [icon]="getTramiteEstadoTagIcon(actividad.estadoDescripcion, actividad.usuarioAsignado)"
          [severity]="getTramiteEstadoTagSeverity(actividad.estadoDescripcion, actividad.usuarioAsignado)"></p-tag>
      </td>
    </tr>
  </ng-template>
</p-table>
<!-- Ultimo Seguimiento -->
@if(estaFinalizado){
<div class="flex flex-column gap-2">
  <h2 class="app-card-header color-form-label font-normal font-roboto-condensed font-18">
    {{ 'msg.ObservacionesSoporteRespuesta' | translate }}
  </h2>
  <div *ngIf="isLoadingSeguimiento">
    <p-skeleton width="12rem"></p-skeleton>
  </div>
  <div *ngIf="!isLoadingSeguimiento" class="flex flex-column gap-2">
    @if (ultimoSeguimientos && ultimoSeguimientos.length > 0) {
    @if(ultimoSeguimientos[0].formularioRespuesta){
    <app-form-respuestas class="w-full" [options]="options"></app-form-respuestas>
    }@else {
    <div class="pb-2">
      {{ultimoSeguimientos[0].comentario}}
    </div>
    }
    }
  </div>
</div>
} @else if(estaRechazado){
<div class="flex flex-column gap-2">
  <h2 class="app-card-header color-form-label font-normal font-roboto-condensed font-18">
    {{ 'msg.ObservacionesSoporteRespuesta' | translate }}
  </h2>
  <div *ngIf="isLoadingSeguimiento">
    <p-skeleton width="12rem"></p-skeleton>
  </div>
  <div *ngIf="!isLoadingSeguimiento" class="flex flex-column gap-2">
    <div class="pb-2">
      {{observaciones}}
    </div>
  </div>
</div>
}

<app-visor />